import {
  allSmartCallFlowActionTypes,
  type ISmartCallFlowActionType,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'
import { AddButtonStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/AddButton/store/AddButtonStore'
import { type SmartCallFlowBuilderStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder'

export const getActions = ({
  getActionById,
  source,
  target,
}: {
  getActionById: SmartCallFlowBuilderStore['getActionById']
  source: string
  target: string
}): ISmartCallFlowActionType[] => {
  const sourceAction = getActionById(source)
  const targetAction = getActionById(target)

  if (targetAction instanceof AddButtonStore) return []

  return allSmartCallFlowActionTypes.filter((type) => {
    let isValid = true
    if (sourceAction?.actionStore) {
      const sourceStore = sourceAction.actionStore
      const branchIndex = sourceStore.nextIds.indexOf(target)
      const allowedList =
        (branchIndex !== -1 && sourceStore.allowedNextActionsByBranchIndex?.[branchIndex]) ||
        sourceStore.allowedNextActions
      if (allowedList && !allowedList.includes(type)) {
        isValid = false
      }
    }
    if (
      targetAction?.actionStore.allowedBeforeActions &&
      !targetAction?.actionStore.allowedBeforeActions.includes(type)
    ) {
      isValid = false
    }
    return isValid
  })
}
